export enum UserEmailPreferencesTypeEnum {
	MembershipConfirmation = 'membership_confirmation',
	OrderConfirmation = 'order_confirmation',
	EmailBlast = 'email_blast',
	EventReminder = 'event_reminder',
	EventSummary = 'event_summary',
	EventCanceled = 'event_canceled',
	EventIsLive = 'event_is_live',
	EventDigest = 'event_digest',
	ChallengeStarts = 'challenge_starts',
	ChallengeWeekStarts = 'challenge_week_starts',
	ChallengeConfirmation = 'challenge_confirmation',
	EventBundleConfirmation = 'event_bundle_confirmation',
}
